module.exports = __webpack_public_path__ + "img/douyin5s.c38ba564.png";